import { Avatar } from 'antd';
import Button from 'components/Button';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { SortableList } from 'features/settingService/components/SortableList';

import settingStaffActions from 'features/settingStaff/services/actions';
import settingApis from 'features/settingStaff/services/apis';
import { useState } from 'react';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { IResponseDataBody } from 'services/response';
import shopActions from 'services/shop/actions';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import toast from 'utils/toast';

const ArrangeStaffModal = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const data = shopSelectors.data.staffs();
  const setLoading = useSetLoadingPage();
  const [items, setItems] = useState<{ id: string, name: string, avatar: string, type: string }[]>([]);
  const handleOpen = () => {
    setItems(data.filter(o => !o.anyBody).map(o => ({ id: o.id, name: o.firstName, avatar: o.urlImage, type: o.staffType })));
    setOpen(true);
  };

  const handleAccept = async () => {
    setOpen(false);

    setLoading(true);
    const ids = items.map(o => o.id);
    try {
      const res: IResponseDataBody<boolean> = await settingApis.sortStaff(ids);
      if (res.data.data) {
        toast.success('Reorder successful');
        dispatch(shopActions.get.newStaffs());
        const params = {
          page: 1,
          size: 20,
          ignoreAnyBody: true,
        };
        dispatch(settingStaffActions.setParams(params));
      }
    } catch (error) { }
    finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button size='small' icon='arrange' ntype='LIGHT_BLUE' onClick={handleOpen}>Reorder booking</Button>
      <Modal
        visible={open}
        onClose={() => setOpen(false)}
        onSubmit={handleAccept}
        modalTitle='Reorder'
      >
        <SortableList
          items={items}
          onChange={setItems}
          renderItem={(item) => (
            <SortableList.Item id={item.id}>
              <CateWrap>
                <Avatar
                  src={item.avatar}
                >
                  {item.name?.[0] || 'A'}
                </Avatar>
                <Text style={{ flex: 1 }} variant="H7" color="text_3">
                  {item.name}
                </Text>
                <Text variant="BODY_1" color="text_3">
                  {item.type}
                </Text>
              </CateWrap>
            </SortableList.Item>
          )}
        />
      </Modal>
    </>
  );
};

export default ArrangeStaffModal;

const CateWrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  .label {
    font-size: 18px;
    font-weight: 600;
  }
`;